/*
 * Copyright (c) 2026 CalAmp Corp. All Rights Reserved
 */
import {dlsAlt, dlsColor, dlsTypography} from '@ion/dls/src/theme/theme';

// covers every state MUI's own MenuItem/ListItem can put a competing grey
// background on (:hover, Mui-selected, Mui-selected:hover reached via
// keyboard/roving-tabindex, Mui-focusVisible from mouseenter-driven focus)
// so none of them can show through as grey instead of blue - extracted to
// a constant since it's long enough to force every sibling key in the
// style object onto the same alignment column otherwise ...
export const CURRENT_THEME_MENU_ITEM_SELECTED_SELECTORS =
  '&:hover, &.Mui-selected, &.Mui-selected:hover, &.Mui-focusVisible';

/**
 * Shared current-theme suggestion-row style for `SearchSuggestions.tsx`'s
 * `suggestionItem` and `DynamicLookUp.tsx`'s `suggestionItem` - two
 * separate MUI style hooks for two sibling components rendered inside the
 * same `MenuList`, which previously duplicated this object verbatim. No
 * explicit font declarations - MUI's own `MenuItem` root class already
 * bakes in `theme.typography.body1` (Inter, 16px, 22px !important
 * line-height) unconditionally, matching Dropdown.tsx's own plain
 * (non-Autocomplete) MenuItem, which likewise declares no font of its own.
 *
 * ```typescript
 * import {currentThemeSuggestionItemStyle} from '@ion/features/src/search/suggestionItemStyles';
 * ...
 *
 * const useStyles = makeStyles(() => ({
 *   suggestionItem : toggleThemeStyle({
 *     height : 40
 *   }, currentThemeSuggestionItemStyle())
 * }));
 * ```
 */
export const currentThemeSuggestionItemStyle = () => ({
  display                                      : 'flex',
  alignItems                                   : 'center',
  gap                                          : '8px',
  padding                                      : '17px !important',
  ...dlsTypography('body2'),
  color                                        : dlsColor('grey1'),
  textTransform                                : 'none',
  [CURRENT_THEME_MENU_ITEM_SELECTED_SELECTORS] : {
    backgroundColor : `${dlsAlt('components', 'icon', 'selected')} !important`
  },
  '&.Mui-disabled' : {
    cursor : 'default'
  }
});
